import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { HeroScreen } from './components/HeroScreen';
import { EpisodeNavScreen } from './components/EpisodeNavScreen';
import { EpisodeViewScreen } from './components/EpisodeViewScreen';
import { Episode2NavScreen } from './components/Episode2NavScreen';
import { Episode3NavScreen } from './components/Episode3NavScreen';
import { Episode4NavScreen } from './components/Episode4NavScreen';
import { Episode5NavScreen } from './components/Episode5NavScreen';
import { Episode6NavScreen } from './components/Episode6NavScreen';
type Screen = 'hero' | 'episode-nav' | 'episode-view' | 'episode-2-nav' | 'episode-3-nav' | 'episode-4-nav' | 'episode-5-nav' | 'episode-6-nav';
export function App() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('hero');
  return <main className="bg-[var(--bg-primary)] min-h-screen w-full text-[var(--text-primary)] overflow-x-hidden selection:bg-[var(--accent)] selection:text-white" data-id="element-0">
      <AnimatePresence mode="wait" data-id="element-1">
        {currentScreen === 'hero' && <HeroScreen key="hero" onStart={() => setCurrentScreen('episode-nav')} data-id="element-2" />}

        {currentScreen === 'episode-nav' && <EpisodeNavScreen key="episode-nav" onPlay={() => setCurrentScreen('episode-view')} onBack={() => setCurrentScreen('hero')} onNextEpisode={() => setCurrentScreen('episode-2-nav')} data-id="element-3" />}

        {currentScreen === 'episode-view' && <EpisodeViewScreen key="episode-view" onBack={() => setCurrentScreen('episode-nav')} data-id="element-4" />}

        {currentScreen === 'episode-2-nav' && <Episode2NavScreen key="episode-2-nav" onBack={() => setCurrentScreen('episode-nav')} onNextEpisode={() => setCurrentScreen('episode-3-nav')} data-id="element-5" />}

        {currentScreen === 'episode-3-nav' && <Episode3NavScreen key="episode-3-nav" onBack={() => setCurrentScreen('episode-2-nav')} onNextEpisode={() => setCurrentScreen('episode-4-nav')} data-id="element-6" />}

        {currentScreen === 'episode-4-nav' && <Episode4NavScreen key="episode-4-nav" onBack={() => setCurrentScreen('episode-3-nav')} onNextEpisode={() => setCurrentScreen('episode-5-nav')} data-id="element-7" />}

        {currentScreen === 'episode-5-nav' && <Episode5NavScreen key="episode-5-nav" onBack={() => setCurrentScreen('episode-4-nav')} onNextEpisode={() => setCurrentScreen('episode-6-nav')} data-id="element-8" />}

        {currentScreen === 'episode-6-nav' && <Episode6NavScreen key="episode-6-nav" onBack={() => setCurrentScreen('episode-5-nav')} data-id="element-9" />}
      </AnimatePresence>
    </main>;
}